<template>
  <div  style="position: relative;padding-bottom: 40px;">
    <ml-table
      :columns="columns"
      :dataSource="dataList"
      :scroll="{ x: tableScrollWidth, y: tableScrollY }"
      style="background-color: #fff; margin: 0 10px"
    >
      <template slot="actions" slot-scope="text, record">
        <a style="margin-right: 5px" @click="implementRepairRecord(record)">{{
          $t("page_workstation_maintain_sure")
        }}</a>
      </template>
    </ml-table>
          <a-pagination
          style="position:absolute;bottom: 4px;right: 20px"
          :total="pagination.total"
          :showTotal="total => `${totalFanyi(total)}`"
          :pageSize="pagination.pageSize"
          :current="pagination.current"
          @change="pageIndexchange"
        ></a-pagination>
  </div>
</template>

<script>
import {
  WarningServiceProxy,
  RepairRecordServiceProxy,
} from "@/service-proxies/app-v2/tpm.service-proxies";
import dayjs from "dayjs";
import { formatTimeSlot } from "@/utils";
const warningServiceProxy = new WarningServiceProxy();
const repairRecordServiceProxy = new RepairRecordServiceProxy();
export default {
  data() {
    return {
      dataList: [],
      tableScrollWidth: 1700,
      tableScrollY: 400,
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
      },
    };
  },
  created() {
    this.getPageRepairRecord();
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("actions"),
          dataIndex: "actions",
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: "actions" },
        },
        {
          title: this.$t("page_plan_maintenance_task_number_jian"),
          dataIndex: "recordCode",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_plan_maintenance_application_form_status_jian"),
          dataIndex: "recordStatusStr",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_tpm_repair_type_jian"),
          dataIndex: "recordType",
          width: 100,
          ellipsis: true,
          customRender: (text) =>
            text === 1
              ? this.$t("page_tpm_repair_temporary_repairs")
              : this.$t("page_tpm_repair_routine_maintenance"),
        },
        {
          title: this.$t("page_plan_maintenance_application_No_jian"),
          dataIndex: "applyCode",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_plan_maintenance_equipment_coding_jian"),
          dataIndex: "deviceCode",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_plan_maintenance_equipment_name_jian"),
          dataIndex: "deviceName",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_plan_maintenance_equipment_type_jian"),
          dataIndex: "deviceTypeName",
          width: 100,
          ellipsis: true,
        },
        // { title: this.$t('规格型号'), dataIndex: 'code', width: 100, ellipsis: true },
        {
          title: this.$t("page_tpm_repair_apply_person_jian"),
          dataIndex: "applyUserName",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_tpm_repair_error_code"),
          dataIndex: "errorCode",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_tpm_repair_apply_time"),
          dataIndex: "applyTime",
          width: 150,
          ellipsis: true,
          customRender: (text) =>
            text ? dayjs(text).format("YYYY-MM-DD HH:mm:ss") : "",
        },
        {
          title: this.$t("page_tpm_repair_occurrence_time"),
          dataIndex: "malfunctionTime",
          width: 150,
          ellipsis: true,
          customRender: (text) =>
            text ? dayjs(text).format("YYYY-MM-DD HH:mm:ss") : "",
        },
        {
          title: this.$t("page_tpm_repair_urgency_jian"),
          dataIndex: "urgencyStr",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_tpm_repair_start_time_jian"),
          dataIndex: "repairStartTime",
          width: 150,
          ellipsis: true,
          customRender: (text) =>
            text ? dayjs(text).format("YYYY-MM-DD HH:mm:ss") : "",
        },
        {
          title: this.$t("page_tpm_repair_end_time_jian"),
          dataIndex: "repairEndTime",
          width: 150,
          ellipsis: true,
          customRender: (text) =>
            text ? dayjs(text).format("YYYY-MM-DD HH:mm:ss") : "",
        },
        {
          title: this.$t("page_tpm_repair_time"),
          dataIndex: "repairTime",
          width: 100,
          ellipsis: true,
          customRender: (text) => (text ? formatTimeSlot(text) : ""),
        },
        {
          title: this.$t("page_tpm_repair_person"),
          dataIndex: "repairUserName",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_extranet_Fault_description"),
          dataIndex: "description",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_tpm_repair_fault_analysis"),
          dataIndex: "malfunctionDetails",
          width: 100,
          ellipsis: true,
        },
      ];
    },
  },
  methods: {
    pageIndexchange(currentPage) {
      this.pagination.current = currentPage;
      this.getPageRepairRecord()
    },
    totalFanyi(number) {
      const total = this.$t("Total…items");
      return total.replace("{0}", number);
    },
    async getPageRepairRecord() {
      let result = await warningServiceProxy.getPageRepairRecord(
        this.pagination.current,
        this.pagination.pageSize
      );
      this.dataList = result.records;
      this.pagination.total = result.total;
    },
    async implementRepairRecord(record) {
      let result = await repairRecordServiceProxy.implementRepairRecord(
        record.id
      );
      if (result) {
        this.$message.success(this.$t("page_resource_pool_success"));
        this.getPageRepairRecord();
      }
    },
  },
};
</script>

<style scoped>
</style>
